<div
  (click)="back()"
  class="d-flex gap-1 align-items-center back"
  style="cursor: pointer"
>
  <i class="fas fa-chevron-right"></i>
  <span>{{ "back-to-tickets" | translate }}</span>
</div>

<div class="custom-card">
  <p class="extra-info">{{ "extra information" | translate }}</p>
  <span class="extra-span">{{ "custom-form-info" | translate }}</span>
  <ng-container>
    <div class="row justify-content-center my-4">
      <div class="col-12">
        <form [formGroup]="infoForm">
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="form-group">
                <app-evento-input
                  [eventoFormControl]="infoForm.get('firstName')"
                  type="text"
                  [label]="'First Name' | translate"
                  [placeholder]="'First Name' | translate"
                  requiredMessage="{{ 'Required Field' | translate }}"
                  invalidCharsMessage="{{
                    'Only Arabic and English letters are allowed' | translate
                  }}"
                  minlengthMessage="{{
                    'Min Length Field' | translate : { value: '2' }
                  }}"
                  maxlengthMessage="{{
                    'Max Length Field' | translate : { value: '30' }
                  }}"
                ></app-evento-input>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-group">
                <app-evento-input
                  [eventoFormControl]="infoForm.get('lastName')"
                  type="text"
                  [label]="'Last Name' | translate"
                  [placeholder]="'Last Name' | translate"
                  requiredMessage="{{ 'Required Field' | translate }}"
                  invalidCharsMessage="{{
                    'Only Arabic and English letters are allowed' | translate
                  }}"
                  minlengthMessage="{{
                    'Min Length Field' | translate : { value: '2' }
                  }}"
                  maxlengthMessage="{{
                    'Max Length Field' | translate : { value: '30' }
                  }}"
                ></app-evento-input>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-group">
                <app-evento-input
                  [eventoFormControl]="infoForm.get('email')"
                  type="text"
                  [label]="'Email' | translate"
                  [placeholder]="'Email' | translate"
                  requiredMessage="{{ 'Required Field' | translate }}"
                  emailMessage="{{ 'Valid Email Address' | translate }}"
                ></app-evento-input>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-group">
                <app-evento-input
                  [eventoFormControl]="infoForm.get('mobile')"
                  type="mobile"
                  [label]="'Mobile number' | translate"
                  [placeholder]="'Mobile number' | translate"
                  requiredMessage="{{ 'Required Field' | translate }}"
                  validatePhoneNumberMessage="{{
                    'Valid Mobile Number' | translate
                  }}"
                ></app-evento-input>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </ng-container>
</div>
